export default class XhqCustomState {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const NOT_SENT = new XhqCustomState(0, '未发送', 'Not Sent')
export const SENT = new XhqCustomState(1, '已发送报关文件', 'Sent')
export const WITHDRAWN = new XhqCustomState(2, '已撤回报关文件', 'Withdrawn')
export const SENT_LCL_TASK = new XhqCustomState(3, '已推送拼箱任务', 'Sent LCL Task')
